import React from 'react';
import './Community.css';
import { FaUsers, FaHeart, FaHandsHelping } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useLanguage } from "../../contexts/LanguageContext";

const Community = () => {
  const { translations: t } = useLanguage();

  const features = [
    {
      icon: <FaUsers className="community-icon" />,
      title: t.community?.supportive?.title || "Support Other’s Posts Proactively",
      description: t.community?.supportive?.description || "Take the initiative in sponsoring community contents and receive direct financial outcomes that help cover your daily needs and pave the way toward a better life."
    },
    {
      icon: <FaHeart className="community-icon" />,
      title: t.community?.authentic?.title || "Profile Rating Capability",
      description: t.community?.authentic?.description || "Elevate your profile by improving performance and interactions with others—higher engagement quality leads to stronger ratings and broader recognition."
    },
    {
      icon: <FaHandsHelping className="community-icon" />,
      title: t.community?.growth?.title || "Authentic and Holistic Growth",
      description: t.community?.growth?.description || "At iWinto, we celebrate every personal journey and actively support sustainable progress."
    }
  ];

  return (
    <section className="community-section" id="community">
      <div className="community-gradient"></div>
      <div className="community-container">
        <motion.h2 
          className="community-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
           {t.community?.header?.title || "Shine Bright... and Start Transforming Your Life"}
        </motion.h2>
        
        <motion.p 
          className="community-subtitle"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
         {t.community?.header?.subtitle || "A comprehensive platform designed to enhance quality of life, elevate business performance, optimize service delivery, and boost income for both individuals and companies."}
        </motion.p>

        <div className="community-features">
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className="feature-item"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              <div className="feature-icon-container">
                {feature.icon}
                <div className="icon-pulse"></div>
              </div>
              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
              <div className="feature-line"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Community;